export default __webpack_public_path__ + "static/media/welcome-bonus-188-ico.a8b8131d.svg";